import { Box, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { getFormattedTransactionDate } from 'pages/payments/transactions/transactions.utils';

type TimelineEventProps = {
  createdDate: string;
  text: string;
  amount?: string;
  description?: string;
  icon: React.ReactNode;
};

const TimelineEvent = ({
  createdDate,
  text,
  amount,
  description,
  icon,
}: TimelineEventProps) => {
  return (
    <Box data-testid="TimelineEvent" display="flex">
      <Box mr={2}>{icon}</Box>
      <Box display="flex" flexDirection="column" width="100%">
        <Box display="flex" flexWrap="nowrap">
          <Box
            component={Typography}
            display="flex"
            flex={1}
            flexWrap="wrap"
            fontWeight="bold"
          >
            {text}
          </Box>
          {amount && (
            <Box component={Typography} display="flex" fontWeight="bold">
              -{amount}
            </Box>
          )}
        </Box>
        {description && <Typography lineHeight={1}>{description}</Typography>}
        <Typography sx={{ color: grey[500] }}>
          {getFormattedTransactionDate(createdDate)}
        </Typography>
      </Box>
    </Box>
  );
};

export default TimelineEvent;
